import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { auth } from '../firebase-config';
import { db } from '../firebase-config';
import { doc, getDoc } from 'firebase/firestore';
// Components
import PageTransition from '../components/PageTransition';
import CourseCard from '../components/CourseCard';
// CSS
import '../assets/css/profile.css';
// Images
import Avatar from '../assets/images/avatar.png';

export default function Profile() {
  const [uid, setUID] = useState('');
  const [avatar, setAvatar] = useState(Avatar);
  const [name, setName] = useState('');
  const [bio, setBio] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [email, setEmail] = useState('');

  useEffect(() => {
    localStorage.removeItem('login_redirect_url');
  }, []);
  
  useEffect(() => {
    getDoc(doc(db, 'Users', auth.currentUser.uid)).then((doc) => {
      const data = doc.data().data;

      setUID(data.uid);
      setAvatar(data.photoURL);
      setName(data.name);
      setMobileNumber(data.mobileNumber);
      setEmail(data.email);
      setBio(data.bio);

      localStorage.setItem('user_data', JSON.stringify(data));
    }).then(() => {
      
    })
  }, [])

  return (
    <div className="profile_page page_body">
      <PageTransition />
      <div className="container">
        <div className="profile_header">
          <div className="profile_image bx_shadow_round select_n">
            <img src={avatar} alt="Forhad Hossain" />
          </div>
          <div className="details">
            <div className="user_name">{name}</div>
            {
              bio === ''?
              <></>
              :
              <div className="user_bio">{bio}</div>
            }
            
            <div className='infos'>
              {
                mobileNumber === ''?
                <></>
                :
                <div className='info'><span className='fas fa-phone'></span> {mobileNumber}</div>
              }
              <div className='info'><span className='fas fa-envelope'></span> {email}</div>
            </div>
            
            <Link to="/edit-profile" className="profile_edit_link btn_primary bg-2  bx_shadow ripple-animate ripple-light">Edit <span className="color_green">Profile</span></Link>
          </div>
        </div>

        <section className="enrolled_courses">
          <div className="section_title_default select_n">Enrolled Courses</div>
          <div className="courses_container">
            {/* <CourseCard
              thumbnail={require('../assets/images/course banners/banner-05.png')}
              title="All you need to know about Freelancing."
              mentor="Forhad Hossain"
              mentorPic=""
              mainPrice=""
              discountPrice=""
              labels={["kdfjdkf"]}
            /> */}
          </div>
        </section>
      </div>
    </div>
  )
}
